export const PRICING_GET_INITIAL_DATA = "PRICING_GET_INITIAL_DATA";
export const PRICING_GET_INITIAL_DATA_SUCCESS = "PRICING_GET_INITIAL_DATA_SUCCESS";
export const PRICING_GET_USER_RATES = "PRICING_GET_USER_RATES";
export const PRICING_GET_USER_RATES_SUCCESS = "PRICING_GET_USER_RATES_SUCCESS_SUCCESS";